import { store } from '@atredux/store'
import { ITool, switchTool } from '@src/redux/slices/toolSlice'
import { getStoresMatch } from '@atredux/selectors/storeSelector'
import { getToolDetailsById } from '@services/ToolMenuConfigService'

export async function syncCurrentToolListener (message) {
    console.log(`Set current tool called in ATB with message: ${JSON.stringify(message)}`)

    const toolId = message.data?.toolId

    if (!toolId) {
        console.error('ATBase: No toolId sent in message, cannot sync current tool from Seaward')
        return
    }
    const toolParameters = message.data.toolParameters
    const hashPath = message.data.hashPath

    const tool: ITool = getToolDetailsById(toolId)

    tool.hashPath = hashPath
    tool.toolParameters = toolParameters

    const state = store.getState()
    const storesMatch = getStoresMatch(state)
    store.dispatch(switchTool({ tool, storesMatch }))

    return true
}
